module.exports = __webpack_public_path__ + "static/media/boss_cafe_think.5f70e37f.png";